import { toggleMark } from "prosemirror-commands";
import curry from "../lib/core/functional/curry";

export const markActive = curry(function markActive(type, state) {
    if (!state.selection) {
        return false;
    }
    let { from, $from, to, empty } = state.selection;
    if (empty) {
        return type.isInSet(state.storedMarks || $from.marks());
    } else {
        return state.doc.rangeHasMark(from, to, type);
    }
});

export const addLink = curry(function addLink(markType, state, dispatch, view) {
    if (markActive(markType, state)) {
        toggleMark(markType)(state, dispatch);
        return true;
    }
    //TODO lets add some pretty prompt interface sometime in the future
    const link = prompt("Please insert the link href");
    if (link) {
        toggleMark(markType, { href: link })(view.state, view.dispatch);
    }
    view.focus();
});
